import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';
import { plural } from '../../../../../../../../../shared/helpers';
import styles from './SelectedProjectsCountBanner.module.less';

type Props = {
  addedProjectsCount: number;
};

/**
 * SelectedProjectsCountBanner will either display the current number
 * of added projects in a release group, or it will display a little
 * "warning" message saying that there are no added projects.
 */
const SelectedProjectsCountBanner: VoidFunctionComponent<Props> = ({ addedProjectsCount }) => {
  const hasNoProjects = addedProjectsCount === 0;
  return (
    <div className={cx(styles.banner, {
      [styles.warning]: hasNoProjects,
    })}>
      {hasNoProjects
        ? 'No projects in release'
        : `${addedProjectsCount} ${plural(addedProjectsCount, 'project')} in release group`}
    </div>
  );
};

export default SelectedProjectsCountBanner;
